import styled from 'styled-components';
import {
  Table,
} from 'antd';
import { COLOR_CV_6 } from 'constants/colors';

// eslint-disable-next-line
export const StyledAntdTable = <T extends Record<string, unknown>>() => styled(Table)<T>`
  & .ant-pagination-item {
    &:focus-visible,
    &:hover {
      border-color: ${COLOR_CV_6};

      & a {
        color: ${COLOR_CV_6};
      }
    }

    &-active {
      &,
      &:hover {
        border-color: ${COLOR_CV_6};
      }

      & a {
        color: ${COLOR_CV_6};
      }
    }
  }

  & .ant-pagination-prev,
  & .ant-pagination-next {
    &:hover,
    &:focus-visible {
      & .ant-pagination-item-link {
        color: ${COLOR_CV_6};
        border-color: ${COLOR_CV_6};
      }
    }
  }

  .ant-table-filter-trigger.active {
    color: ${COLOR_CV_6};
  }

  .ant-table-column-sorter-up.active,
  .ant-table-column-sorter-down.active {
    color: ${COLOR_CV_6};
  }

  & .ant-table-row-expand-icon:focus,
  & .ant-table-row-expand-icon:hover {
    color: ${COLOR_CV_6};
  }
`;
